import React, { useState } from "react";
import { navigate } from "gatsby";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

// styles
import * as styles from "./EmpaneledDoctors.module.css";

// data
import DOCTORS_DATA from "./doctorData";

// components
import DoctorCarousel from "./DoctorCarousel";
import DoctorDetailModal from "./DoctorDetailModal";

const EmpaneledDoctors = ({
  maxDoctors = 6,
  showLoadMore = true,
  autoPlay = true,
  autoPlayInterval = 3000,
  showDots = false,
  showArrows = false,
  onCtaClick = () => {},
}) => {
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDoctorClick = doctor => {
    setSelectedDoctor(doctor);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedDoctor(null), 300);
  };

  const handleLoadMore = () => {
    navigate("/doctor-list");
    onCtaClick("Load more");
  };

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <section className={styles.empaneledDoctorsSection}>
      <div
        className={`scroll_animate ${styles.container} ${inView && "inview"}`}
        ref={ref}
      >
        <div className={styles.header}>
          <h2 className={styles.title}>Empaneled Doctors</h2>
        </div>

        <DoctorCarousel
          doctors={DOCTORS_DATA}
          onDoctorClick={handleDoctorClick}
          maxDoctors={maxDoctors}
          autoPlay={autoPlay}
          autoPlayInterval={autoPlayInterval}
          showDots={showDots}
          showArrows={showArrows}
        />

        {showLoadMore && (
          <div className={styles.loadMoreWrapper}>
            <button className={styles.loadMoreButton} onClick={handleLoadMore}>
              Load more
            </button>
          </div>
        )}
      </div>

      <DoctorDetailModal
        doctor={selectedDoctor}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </section>
  );
};

EmpaneledDoctors.propTypes = {
  maxDoctors: PropTypes.number,
  showLoadMore: PropTypes.bool,
  autoPlay: PropTypes.bool,
  autoPlayInterval: PropTypes.number,
  showDots: PropTypes.bool,
  showArrows: PropTypes.bool,
  onCtaClick: PropTypes.func,
};

export default EmpaneledDoctors;
